import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { FeatureFlags } from '~src/ts/FeatureFlags';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { UserDefinedPoolModel } from '../types/PoolModel';
import { AddNewPoolButton } from './AddNewPoolButton';
import { BridgeMultiPoolTableBody } from './BridgeMultiPoolTableBody';
import { BridgeMultiPoolTableHeaders } from './BridgeMultiPoolTableHeaders';

export type BridgeMultiPoolSectionProps = Readonly<{
  pools: Record<string, UserDefinedPoolModel>;
  connectionStatuses: IRemoteAgentConnectionStatus[];
  siteId: string;
  refreshEdgePools: () => void;
  hasLoadedEdgePools: boolean;
}>

export function BridgeMultiPoolSection(props: BridgeMultiPoolSectionProps) {
  const existingPoolNames = Object.values(props.pools).map((pool: UserDefinedPoolModel) => pool.displayName);

  return (FeatureFlags.edgeMultiPoolEnabled ?
    <div className={sectionExtraPaddingBottom}>
      <AddNewPoolButton existingPoolNames={existingPoolNames} siteId={props.siteId} refreshEdgePools={props.refreshEdgePools} />
      <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
        <BridgeMultiPoolTableHeaders />
        <BridgeMultiPoolTableBody
          pools={props.pools}
          existingPoolNames={existingPoolNames}
          connectionStatuses={props.connectionStatuses}
          siteId={props.siteId}
          refreshEdgePools={props.refreshEdgePools}
          hasLoadedEdgePools={props.hasLoadedEdgePools}
        />
      </table>
    </div>
    :
    null
  );
}

export const sectionExtraPaddingBottom = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const multiPoolTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default'
});
